import React from 'react';
import styled from 'styled-components';

const AnvGenContainer = (props: IAnvGenContainerProps) => {
  const { anvgen } = props;
  let backgroundColor = '#C8D2DB';
  switch (anvgen) {
    case 11:
      backgroundColor = '#E1B7A0';
      break;
    case 21:
      backgroundColor = '#CA9FA0';
      break;
    case 31:
      backgroundColor = '#B5DAE4';
      break;
    case 41:
      backgroundColor = '#E3B2CD';
      break;
    case 51:
      backgroundColor = '#DAEAC7';
      break;
    case 61:
      backgroundColor = '#F2DCB5';
      break;
    case 71:
      backgroundColor = '#EFECAB';
      break;
    case 81:
      backgroundColor = '#BCC2DB';
      break;
    case 91:
      backgroundColor = '#B9E1CE';
      break;
    case 96:
      backgroundColor = '#D1D1D5';
      break;
    default:
      break;
  }
  return <Wrapper style={{ backgroundColor: backgroundColor }} />;
};
const Wrapper = styled.div`
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 100%;
`;
interface IAnvGenContainerProps {
  anvgen: number;
}

export default AnvGenContainer;
